import React, { useEffect, useState } from 'react';
import { useProgressiveNumber } from '../hooks/useProgressiveNumber';
import { Input } from './ui/Input';
import { AlertCircle, CheckCircle2 } from 'lucide-react';
interface ProgressiveNumberInputProps {
  type: 'client' | 'contract' | 'nc' | 'invoice' | 'proforma' | 'credit_note' | 'deadline' | 'equipment' | 'improvement';
  value?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
  year?: number;
  label?: string;
  required?: boolean;
}
export function ProgressiveNumberInput({
  type,
  value,
  onChange,
  disabled,
  year,
  label,
  required
}: ProgressiveNumberInputProps) {
  const {
    suggestNext,
    checkAvailability
  } = useProgressiveNumber();
  const [isChecking, setIsChecking] = useState(false);
  const [isAvailable, setIsAvailable] = useState<boolean | null>(null);
  const [suggestedNumber, setSuggestedNumber] = useState('');
  useEffect(() => {
    // Suggest number on mount if no value
    if (!value && onChange) {
      const suggested = suggestNext(type, year);
      setSuggestedNumber(suggested);
      onChange(suggested);
    }
  }, [type, year, onChange, value, suggestNext]);
  useEffect(() => {
    // Check availability when value changes
    if (value && value !== suggestedNumber) {
      setIsChecking(true);
      const timer = setTimeout(() => {
        const available = checkAvailability(type, value);
        setIsAvailable(available);
        setIsChecking(false);
      }, 500);
      return () => clearTimeout(timer);
    } else {
      setIsAvailable(true);
    }
  }, [value, type, suggestedNumber]);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };
  return <div className="relative" data-id="element-309">
      <Input label={label || 'Numero'} value={value || ''} onChange={handleChange} disabled={disabled} required={required} endContent={isChecking ? <div className="animate-spin h-4 w-4 border-2 border-seform-orange border-t-transparent rounded-full" data-id="element-311"></div> : isAvailable === false ? <AlertCircle className="h-4 w-4 text-red-500" data-id="element-312" /> : isAvailable === true && value ? <CheckCircle2 className="h-4 w-4 text-green-500" data-id="element-313" /> : null} error={isAvailable === false ? 'Numero già in uso' : undefined} description={!value && suggestedNumber ? `Numero suggerito: ${suggestedNumber}` : undefined} data-id="element-310" />
    </div>;
}